/* eslint-disable */
// GENERATED FILE. Do not edit by hand.
// Regenerate: pnpm --filter @tellescope/i18n generate:locales
// Kept in sync by the pre-commit hook and prepare-translations; CI fails if this file is stale.
//
// Why a static index instead of `import.meta.glob`: that API is Vite-only, and this package must stay
// importable from Node (Lambda, scripts) and React Native. See CLAUDE.md.
import type { Resource } from "i18next";

import de_account from "./locales/de/account.json";
import de_ai_agent from "./locales/de/ai-agent.json";
import de_ai from "./locales/de/ai.json";
import de_appointment_reminders from "./locales/de/appointment-reminders.json";
import de_appointments from "./locales/de/appointments.json";
import de_auth from "./locales/de/auth.json";
import de_button from "./locales/de/button.json";
import de_buttons from "./locales/de/buttons.json";
import de_calendar from "./locales/de/calendar.json";
import de_call_queues from "./locales/de/call-queues.json";
import de_calling from "./locales/de/calling.json";
import de_common from "./locales/de/common.json";
import de_contact from "./locales/de/contact.json";
import de_contacts from "./locales/de/contacts.json";
import de_content from "./locales/de/content.json";
import de_dashboard from "./locales/de/dashboard.json";
import de_dates from "./locales/de/dates.json";
import de_device_orders from "./locales/de/device-orders.json";
import de_eligibility from "./locales/de/eligibility.json";
import de_email from "./locales/de/email.json";
import de_emojis from "./locales/de/emojis.json";
import de_encounters from "./locales/de/encounters.json";
import de_endusers from "./locales/de/endusers.json";
import de_events from "./locales/de/events.json";
import de_files from "./locales/de/files.json";
import de_forms from "./locales/de/forms.json";
import de_inbox from "./locales/de/inbox.json";
import de_layout from "./locales/de/layout.json";
import de_llm_testbench from "./locales/de/llm-testbench.json";
import de_medications from "./locales/de/medications.json";
import de_messages from "./locales/de/messages.json";
import de_messaging from "./locales/de/messaging.json";
import de_mfa from "./locales/de/mfa.json";
import de_missing from "./locales/de/missing.json";
import de_navigation from "./locales/de/navigation.json";
import de_notifications from "./locales/de/notifications.json";
import de_onboarding from "./locales/de/onboarding.json";
import de_orders from "./locales/de/orders.json";
import de_payments from "./locales/de/payments.json";
import de_portal from "./locales/de/portal.json";
import de_prototypes from "./locales/de/prototypes.json";
import de_purchases from "./locales/de/purchases.json";
import de_routing from "./locales/de/routing.json";
import de_scripts from "./locales/de/scripts.json";
import de_settings from "./locales/de/settings.json";
import de_shop from "./locales/de/shop.json";
import de_sidebar from "./locales/de/sidebar.json";
import de_tags from "./locales/de/tags.json";
import de_team_chat from "./locales/de/team-chat.json";
import de_team_channel from "./locales/de/team_channel.json";
import de_templates from "./locales/de/templates.json";
import de_test from "./locales/de/test.json";
import de_ticket_queues from "./locales/de/ticket-queues.json";
import de_tickets from "./locales/de/tickets.json";
import de_timeline from "./locales/de/timeline.json";
import de_ui from "./locales/de/ui.json";
import de_unsubscribe from "./locales/de/unsubscribe.json";
import de_utils from "./locales/de/utils.json";
import de_videoCalling from "./locales/de/videoCalling.json";
import de_vitals from "./locales/de/vitals.json";
import en_account from "./locales/en/account.json";
import en_ai_agent from "./locales/en/ai-agent.json";
import en_ai from "./locales/en/ai.json";
import en_appointment_reminders from "./locales/en/appointment-reminders.json";
import en_appointments from "./locales/en/appointments.json";
import en_auth from "./locales/en/auth.json";
import en_button from "./locales/en/button.json";
import en_buttons from "./locales/en/buttons.json";
import en_calendar from "./locales/en/calendar.json";
import en_call_queues from "./locales/en/call-queues.json";
import en_calling from "./locales/en/calling.json";
import en_common from "./locales/en/common.json";
import en_contact from "./locales/en/contact.json";
import en_contacts from "./locales/en/contacts.json";
import en_content from "./locales/en/content.json";
import en_dashboard from "./locales/en/dashboard.json";
import en_dates from "./locales/en/dates.json";
import en_device_orders from "./locales/en/device-orders.json";
import en_eligibility from "./locales/en/eligibility.json";
import en_email from "./locales/en/email.json";
import en_emojis from "./locales/en/emojis.json";
import en_encounters from "./locales/en/encounters.json";
import en_endusers from "./locales/en/endusers.json";
import en_events from "./locales/en/events.json";
import en_files from "./locales/en/files.json";
import en_forms from "./locales/en/forms.json";
import en_inbox from "./locales/en/inbox.json";
import en_layout from "./locales/en/layout.json";
import en_llm_testbench from "./locales/en/llm-testbench.json";
import en_medications from "./locales/en/medications.json";
import en_messages from "./locales/en/messages.json";
import en_messaging from "./locales/en/messaging.json";
import en_mfa from "./locales/en/mfa.json";
import en_missing from "./locales/en/missing.json";
import en_navigation from "./locales/en/navigation.json";
import en_notifications from "./locales/en/notifications.json";
import en_onboarding from "./locales/en/onboarding.json";
import en_orders from "./locales/en/orders.json";
import en_payments from "./locales/en/payments.json";
import en_portal from "./locales/en/portal.json";
import en_prototypes from "./locales/en/prototypes.json";
import en_purchases from "./locales/en/purchases.json";
import en_routing from "./locales/en/routing.json";
import en_scripts from "./locales/en/scripts.json";
import en_settings from "./locales/en/settings.json";
import en_shop from "./locales/en/shop.json";
import en_sidebar from "./locales/en/sidebar.json";
import en_tags from "./locales/en/tags.json";
import en_team_chat from "./locales/en/team-chat.json";
import en_team_channel from "./locales/en/team_channel.json";
import en_templates from "./locales/en/templates.json";
import en_test from "./locales/en/test.json";
import en_ticket_queues from "./locales/en/ticket-queues.json";
import en_tickets from "./locales/en/tickets.json";
import en_timeline from "./locales/en/timeline.json";
import en_ui from "./locales/en/ui.json";
import en_unsubscribe from "./locales/en/unsubscribe.json";
import en_utils from "./locales/en/utils.json";
import en_videoCalling from "./locales/en/videoCalling.json";
import en_vitals from "./locales/en/vitals.json";
import es_account from "./locales/es/account.json";
import es_ai_agent from "./locales/es/ai-agent.json";
import es_ai from "./locales/es/ai.json";
import es_appointment_reminders from "./locales/es/appointment-reminders.json";
import es_appointments from "./locales/es/appointments.json";
import es_auth from "./locales/es/auth.json";
import es_button from "./locales/es/button.json";
import es_buttons from "./locales/es/buttons.json";
import es_calendar from "./locales/es/calendar.json";
import es_call_queues from "./locales/es/call-queues.json";
import es_calling from "./locales/es/calling.json";
import es_common from "./locales/es/common.json";
import es_contact from "./locales/es/contact.json";
import es_contacts from "./locales/es/contacts.json";
import es_content from "./locales/es/content.json";
import es_dashboard from "./locales/es/dashboard.json";
import es_dates from "./locales/es/dates.json";
import es_device_orders from "./locales/es/device-orders.json";
import es_eligibility from "./locales/es/eligibility.json";
import es_email from "./locales/es/email.json";
import es_emojis from "./locales/es/emojis.json";
import es_encounters from "./locales/es/encounters.json";
import es_endusers from "./locales/es/endusers.json";
import es_events from "./locales/es/events.json";
import es_files from "./locales/es/files.json";
import es_forms from "./locales/es/forms.json";
import es_inbox from "./locales/es/inbox.json";
import es_layout from "./locales/es/layout.json";
import es_llm_testbench from "./locales/es/llm-testbench.json";
import es_medications from "./locales/es/medications.json";
import es_messages from "./locales/es/messages.json";
import es_messaging from "./locales/es/messaging.json";
import es_mfa from "./locales/es/mfa.json";
import es_missing from "./locales/es/missing.json";
import es_navigation from "./locales/es/navigation.json";
import es_notifications from "./locales/es/notifications.json";
import es_onboarding from "./locales/es/onboarding.json";
import es_orders from "./locales/es/orders.json";
import es_payments from "./locales/es/payments.json";
import es_portal from "./locales/es/portal.json";
import es_prototypes from "./locales/es/prototypes.json";
import es_purchases from "./locales/es/purchases.json";
import es_routing from "./locales/es/routing.json";
import es_scripts from "./locales/es/scripts.json";
import es_settings from "./locales/es/settings.json";
import es_shop from "./locales/es/shop.json";
import es_sidebar from "./locales/es/sidebar.json";
import es_tags from "./locales/es/tags.json";
import es_team_chat from "./locales/es/team-chat.json";
import es_team_channel from "./locales/es/team_channel.json";
import es_templates from "./locales/es/templates.json";
import es_test from "./locales/es/test.json";
import es_ticket_queues from "./locales/es/ticket-queues.json";
import es_tickets from "./locales/es/tickets.json";
import es_timeline from "./locales/es/timeline.json";
import es_ui from "./locales/es/ui.json";
import es_unsubscribe from "./locales/es/unsubscribe.json";
import es_utils from "./locales/es/utils.json";
import es_videoCalling from "./locales/es/videoCalling.json";
import es_vitals from "./locales/es/vitals.json";
import fr_account from "./locales/fr/account.json";
import fr_ai_agent from "./locales/fr/ai-agent.json";
import fr_ai from "./locales/fr/ai.json";
import fr_appointment_reminders from "./locales/fr/appointment-reminders.json";
import fr_appointments from "./locales/fr/appointments.json";
import fr_auth from "./locales/fr/auth.json";
import fr_button from "./locales/fr/button.json";
import fr_buttons from "./locales/fr/buttons.json";
import fr_calendar from "./locales/fr/calendar.json";
import fr_call_queues from "./locales/fr/call-queues.json";
import fr_calling from "./locales/fr/calling.json";
import fr_common from "./locales/fr/common.json";
import fr_contact from "./locales/fr/contact.json";
import fr_contacts from "./locales/fr/contacts.json";
import fr_content from "./locales/fr/content.json";
import fr_dashboard from "./locales/fr/dashboard.json";
import fr_dates from "./locales/fr/dates.json";
import fr_device_orders from "./locales/fr/device-orders.json";
import fr_eligibility from "./locales/fr/eligibility.json";
import fr_email from "./locales/fr/email.json";
import fr_emojis from "./locales/fr/emojis.json";
import fr_encounters from "./locales/fr/encounters.json";
import fr_endusers from "./locales/fr/endusers.json";
import fr_events from "./locales/fr/events.json";
import fr_files from "./locales/fr/files.json";
import fr_forms from "./locales/fr/forms.json";
import fr_inbox from "./locales/fr/inbox.json";
import fr_layout from "./locales/fr/layout.json";
import fr_llm_testbench from "./locales/fr/llm-testbench.json";
import fr_medications from "./locales/fr/medications.json";
import fr_messages from "./locales/fr/messages.json";
import fr_messaging from "./locales/fr/messaging.json";
import fr_mfa from "./locales/fr/mfa.json";
import fr_missing from "./locales/fr/missing.json";
import fr_navigation from "./locales/fr/navigation.json";
import fr_notifications from "./locales/fr/notifications.json";
import fr_onboarding from "./locales/fr/onboarding.json";
import fr_orders from "./locales/fr/orders.json";
import fr_payments from "./locales/fr/payments.json";
import fr_portal from "./locales/fr/portal.json";
import fr_prototypes from "./locales/fr/prototypes.json";
import fr_purchases from "./locales/fr/purchases.json";
import fr_routing from "./locales/fr/routing.json";
import fr_scripts from "./locales/fr/scripts.json";
import fr_settings from "./locales/fr/settings.json";
import fr_shop from "./locales/fr/shop.json";
import fr_sidebar from "./locales/fr/sidebar.json";
import fr_tags from "./locales/fr/tags.json";
import fr_team_chat from "./locales/fr/team-chat.json";
import fr_team_channel from "./locales/fr/team_channel.json";
import fr_templates from "./locales/fr/templates.json";
import fr_test from "./locales/fr/test.json";
import fr_ticket_queues from "./locales/fr/ticket-queues.json";
import fr_tickets from "./locales/fr/tickets.json";
import fr_timeline from "./locales/fr/timeline.json";
import fr_ui from "./locales/fr/ui.json";
import fr_unsubscribe from "./locales/fr/unsubscribe.json";
import fr_utils from "./locales/fr/utils.json";
import fr_videoCalling from "./locales/fr/videoCalling.json";
import fr_vitals from "./locales/fr/vitals.json";
import zh_account from "./locales/zh/account.json";
import zh_ai_agent from "./locales/zh/ai-agent.json";
import zh_ai from "./locales/zh/ai.json";
import zh_appointment_reminders from "./locales/zh/appointment-reminders.json";
import zh_appointments from "./locales/zh/appointments.json";
import zh_auth from "./locales/zh/auth.json";
import zh_button from "./locales/zh/button.json";
import zh_buttons from "./locales/zh/buttons.json";
import zh_calendar from "./locales/zh/calendar.json";
import zh_call_queues from "./locales/zh/call-queues.json";
import zh_calling from "./locales/zh/calling.json";
import zh_common from "./locales/zh/common.json";
import zh_contact from "./locales/zh/contact.json";
import zh_contacts from "./locales/zh/contacts.json";
import zh_content from "./locales/zh/content.json";
import zh_dashboard from "./locales/zh/dashboard.json";
import zh_dates from "./locales/zh/dates.json";
import zh_device_orders from "./locales/zh/device-orders.json";
import zh_eligibility from "./locales/zh/eligibility.json";
import zh_email from "./locales/zh/email.json";
import zh_emojis from "./locales/zh/emojis.json";
import zh_encounters from "./locales/zh/encounters.json";
import zh_endusers from "./locales/zh/endusers.json";
import zh_events from "./locales/zh/events.json";
import zh_files from "./locales/zh/files.json";
import zh_forms from "./locales/zh/forms.json";
import zh_inbox from "./locales/zh/inbox.json";
import zh_layout from "./locales/zh/layout.json";
import zh_llm_testbench from "./locales/zh/llm-testbench.json";
import zh_medications from "./locales/zh/medications.json";
import zh_messages from "./locales/zh/messages.json";
import zh_messaging from "./locales/zh/messaging.json";
import zh_mfa from "./locales/zh/mfa.json";
import zh_missing from "./locales/zh/missing.json";
import zh_navigation from "./locales/zh/navigation.json";
import zh_notifications from "./locales/zh/notifications.json";
import zh_onboarding from "./locales/zh/onboarding.json";
import zh_orders from "./locales/zh/orders.json";
import zh_payments from "./locales/zh/payments.json";
import zh_portal from "./locales/zh/portal.json";
import zh_prototypes from "./locales/zh/prototypes.json";
import zh_purchases from "./locales/zh/purchases.json";
import zh_routing from "./locales/zh/routing.json";
import zh_scripts from "./locales/zh/scripts.json";
import zh_settings from "./locales/zh/settings.json";
import zh_shop from "./locales/zh/shop.json";
import zh_sidebar from "./locales/zh/sidebar.json";
import zh_tags from "./locales/zh/tags.json";
import zh_team_chat from "./locales/zh/team-chat.json";
import zh_team_channel from "./locales/zh/team_channel.json";
import zh_templates from "./locales/zh/templates.json";
import zh_test from "./locales/zh/test.json";
import zh_ticket_queues from "./locales/zh/ticket-queues.json";
import zh_tickets from "./locales/zh/tickets.json";
import zh_timeline from "./locales/zh/timeline.json";
import zh_ui from "./locales/zh/ui.json";
import zh_unsubscribe from "./locales/zh/unsubscribe.json";
import zh_utils from "./locales/zh/utils.json";
import zh_videoCalling from "./locales/zh/videoCalling.json";
import zh_vitals from "./locales/zh/vitals.json";

/** Every locale namespace on disk, sorted. */
export const localeNamespaces: readonly string[] = [
  "account",
  "ai",
  "ai-agent",
  "appointment-reminders",
  "appointments",
  "auth",
  "button",
  "buttons",
  "calendar",
  "call-queues",
  "calling",
  "common",
  "contact",
  "contacts",
  "content",
  "dashboard",
  "dates",
  "device-orders",
  "eligibility",
  "email",
  "emojis",
  "encounters",
  "endusers",
  "events",
  "files",
  "forms",
  "inbox",
  "layout",
  "llm-testbench",
  "medications",
  "messages",
  "messaging",
  "mfa",
  "missing",
  "navigation",
  "notifications",
  "onboarding",
  "orders",
  "payments",
  "portal",
  "prototypes",
  "purchases",
  "routing",
  "scripts",
  "settings",
  "shop",
  "sidebar",
  "tags",
  "team-chat",
  "team_channel",
  "templates",
  "test",
  "ticket-queues",
  "tickets",
  "timeline",
  "ui",
  "unsubscribe",
  "utils",
  "videoCalling",
  "vitals",
];

/** All locale resources, keyed by language and then namespace. */
export const localeResources: Resource = {
  de: {
    "account": de_account,
    "ai-agent": de_ai_agent,
    "ai": de_ai,
    "appointment-reminders": de_appointment_reminders,
    "appointments": de_appointments,
    "auth": de_auth,
    "button": de_button,
    "buttons": de_buttons,
    "calendar": de_calendar,
    "call-queues": de_call_queues,
    "calling": de_calling,
    "common": de_common,
    "contact": de_contact,
    "contacts": de_contacts,
    "content": de_content,
    "dashboard": de_dashboard,
    "dates": de_dates,
    "device-orders": de_device_orders,
    "eligibility": de_eligibility,
    "email": de_email,
    "emojis": de_emojis,
    "encounters": de_encounters,
    "endusers": de_endusers,
    "events": de_events,
    "files": de_files,
    "forms": de_forms,
    "inbox": de_inbox,
    "layout": de_layout,
    "llm-testbench": de_llm_testbench,
    "medications": de_medications,
    "messages": de_messages,
    "messaging": de_messaging,
    "mfa": de_mfa,
    "missing": de_missing,
    "navigation": de_navigation,
    "notifications": de_notifications,
    "onboarding": de_onboarding,
    "orders": de_orders,
    "payments": de_payments,
    "portal": de_portal,
    "prototypes": de_prototypes,
    "purchases": de_purchases,
    "routing": de_routing,
    "scripts": de_scripts,
    "settings": de_settings,
    "shop": de_shop,
    "sidebar": de_sidebar,
    "tags": de_tags,
    "team-chat": de_team_chat,
    "team_channel": de_team_channel,
    "templates": de_templates,
    "test": de_test,
    "ticket-queues": de_ticket_queues,
    "tickets": de_tickets,
    "timeline": de_timeline,
    "ui": de_ui,
    "unsubscribe": de_unsubscribe,
    "utils": de_utils,
    "videoCalling": de_videoCalling,
    "vitals": de_vitals,
  },
  en: {
    "account": en_account,
    "ai-agent": en_ai_agent,
    "ai": en_ai,
    "appointment-reminders": en_appointment_reminders,
    "appointments": en_appointments,
    "auth": en_auth,
    "button": en_button,
    "buttons": en_buttons,
    "calendar": en_calendar,
    "call-queues": en_call_queues,
    "calling": en_calling,
    "common": en_common,
    "contact": en_contact,
    "contacts": en_contacts,
    "content": en_content,
    "dashboard": en_dashboard,
    "dates": en_dates,
    "device-orders": en_device_orders,
    "eligibility": en_eligibility,
    "email": en_email,
    "emojis": en_emojis,
    "encounters": en_encounters,
    "endusers": en_endusers,
    "events": en_events,
    "files": en_files,
    "forms": en_forms,
    "inbox": en_inbox,
    "layout": en_layout,
    "llm-testbench": en_llm_testbench,
    "medications": en_medications,
    "messages": en_messages,
    "messaging": en_messaging,
    "mfa": en_mfa,
    "missing": en_missing,
    "navigation": en_navigation,
    "notifications": en_notifications,
    "onboarding": en_onboarding,
    "orders": en_orders,
    "payments": en_payments,
    "portal": en_portal,
    "prototypes": en_prototypes,
    "purchases": en_purchases,
    "routing": en_routing,
    "scripts": en_scripts,
    "settings": en_settings,
    "shop": en_shop,
    "sidebar": en_sidebar,
    "tags": en_tags,
    "team-chat": en_team_chat,
    "team_channel": en_team_channel,
    "templates": en_templates,
    "test": en_test,
    "ticket-queues": en_ticket_queues,
    "tickets": en_tickets,
    "timeline": en_timeline,
    "ui": en_ui,
    "unsubscribe": en_unsubscribe,
    "utils": en_utils,
    "videoCalling": en_videoCalling,
    "vitals": en_vitals,
  },
  es: {
    "account": es_account,
    "ai-agent": es_ai_agent,
    "ai": es_ai,
    "appointment-reminders": es_appointment_reminders,
    "appointments": es_appointments,
    "auth": es_auth,
    "button": es_button,
    "buttons": es_buttons,
    "calendar": es_calendar,
    "call-queues": es_call_queues,
    "calling": es_calling,
    "common": es_common,
    "contact": es_contact,
    "contacts": es_contacts,
    "content": es_content,
    "dashboard": es_dashboard,
    "dates": es_dates,
    "device-orders": es_device_orders,
    "eligibility": es_eligibility,
    "email": es_email,
    "emojis": es_emojis,
    "encounters": es_encounters,
    "endusers": es_endusers,
    "events": es_events,
    "files": es_files,
    "forms": es_forms,
    "inbox": es_inbox,
    "layout": es_layout,
    "llm-testbench": es_llm_testbench,
    "medications": es_medications,
    "messages": es_messages,
    "messaging": es_messaging,
    "mfa": es_mfa,
    "missing": es_missing,
    "navigation": es_navigation,
    "notifications": es_notifications,
    "onboarding": es_onboarding,
    "orders": es_orders,
    "payments": es_payments,
    "portal": es_portal,
    "prototypes": es_prototypes,
    "purchases": es_purchases,
    "routing": es_routing,
    "scripts": es_scripts,
    "settings": es_settings,
    "shop": es_shop,
    "sidebar": es_sidebar,
    "tags": es_tags,
    "team-chat": es_team_chat,
    "team_channel": es_team_channel,
    "templates": es_templates,
    "test": es_test,
    "ticket-queues": es_ticket_queues,
    "tickets": es_tickets,
    "timeline": es_timeline,
    "ui": es_ui,
    "unsubscribe": es_unsubscribe,
    "utils": es_utils,
    "videoCalling": es_videoCalling,
    "vitals": es_vitals,
  },
  fr: {
    "account": fr_account,
    "ai-agent": fr_ai_agent,
    "ai": fr_ai,
    "appointment-reminders": fr_appointment_reminders,
    "appointments": fr_appointments,
    "auth": fr_auth,
    "button": fr_button,
    "buttons": fr_buttons,
    "calendar": fr_calendar,
    "call-queues": fr_call_queues,
    "calling": fr_calling,
    "common": fr_common,
    "contact": fr_contact,
    "contacts": fr_contacts,
    "content": fr_content,
    "dashboard": fr_dashboard,
    "dates": fr_dates,
    "device-orders": fr_device_orders,
    "eligibility": fr_eligibility,
    "email": fr_email,
    "emojis": fr_emojis,
    "encounters": fr_encounters,
    "endusers": fr_endusers,
    "events": fr_events,
    "files": fr_files,
    "forms": fr_forms,
    "inbox": fr_inbox,
    "layout": fr_layout,
    "llm-testbench": fr_llm_testbench,
    "medications": fr_medications,
    "messages": fr_messages,
    "messaging": fr_messaging,
    "mfa": fr_mfa,
    "missing": fr_missing,
    "navigation": fr_navigation,
    "notifications": fr_notifications,
    "onboarding": fr_onboarding,
    "orders": fr_orders,
    "payments": fr_payments,
    "portal": fr_portal,
    "prototypes": fr_prototypes,
    "purchases": fr_purchases,
    "routing": fr_routing,
    "scripts": fr_scripts,
    "settings": fr_settings,
    "shop": fr_shop,
    "sidebar": fr_sidebar,
    "tags": fr_tags,
    "team-chat": fr_team_chat,
    "team_channel": fr_team_channel,
    "templates": fr_templates,
    "test": fr_test,
    "ticket-queues": fr_ticket_queues,
    "tickets": fr_tickets,
    "timeline": fr_timeline,
    "ui": fr_ui,
    "unsubscribe": fr_unsubscribe,
    "utils": fr_utils,
    "videoCalling": fr_videoCalling,
    "vitals": fr_vitals,
  },
  zh: {
    "account": zh_account,
    "ai-agent": zh_ai_agent,
    "ai": zh_ai,
    "appointment-reminders": zh_appointment_reminders,
    "appointments": zh_appointments,
    "auth": zh_auth,
    "button": zh_button,
    "buttons": zh_buttons,
    "calendar": zh_calendar,
    "call-queues": zh_call_queues,
    "calling": zh_calling,
    "common": zh_common,
    "contact": zh_contact,
    "contacts": zh_contacts,
    "content": zh_content,
    "dashboard": zh_dashboard,
    "dates": zh_dates,
    "device-orders": zh_device_orders,
    "eligibility": zh_eligibility,
    "email": zh_email,
    "emojis": zh_emojis,
    "encounters": zh_encounters,
    "endusers": zh_endusers,
    "events": zh_events,
    "files": zh_files,
    "forms": zh_forms,
    "inbox": zh_inbox,
    "layout": zh_layout,
    "llm-testbench": zh_llm_testbench,
    "medications": zh_medications,
    "messages": zh_messages,
    "messaging": zh_messaging,
    "mfa": zh_mfa,
    "missing": zh_missing,
    "navigation": zh_navigation,
    "notifications": zh_notifications,
    "onboarding": zh_onboarding,
    "orders": zh_orders,
    "payments": zh_payments,
    "portal": zh_portal,
    "prototypes": zh_prototypes,
    "purchases": zh_purchases,
    "routing": zh_routing,
    "scripts": zh_scripts,
    "settings": zh_settings,
    "shop": zh_shop,
    "sidebar": zh_sidebar,
    "tags": zh_tags,
    "team-chat": zh_team_chat,
    "team_channel": zh_team_channel,
    "templates": zh_templates,
    "test": zh_test,
    "ticket-queues": zh_ticket_queues,
    "tickets": zh_tickets,
    "timeline": zh_timeline,
    "ui": zh_ui,
    "unsubscribe": zh_unsubscribe,
    "utils": zh_utils,
    "videoCalling": zh_videoCalling,
    "vitals": zh_vitals,
  },
};
